import { inject, Injectable, OnDestroy } from '@angular/core';
import { UserApiClient } from '../api-clients';
import { BehaviorSubject, first, shareReplay, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileStore implements OnDestroy {
  private readonly _userApiClient = inject(UserApiClient);

  private readonly profileInfoSource$ = new BehaviorSubject<boolean>(false);

  readonly profileInfo$ = this.profileInfoSource$.pipe(
    switchMap(() => this._userApiClient.getUserProfile().pipe(first())),
    shareReplay(1)
  );

  ngOnDestroy(): void {
    this.profileInfoSource$.complete();
  }

  updateProfileInfo() {
    this.profileInfoSource$.next(true);
  }
}
